/**
 * 汎用Popupフォーム管理
 */
import {common_init_service} from '../init_service/main'
import {dom_service}  from '../dom_service/main'
var popup_form_service = {
  conf: {
    use_ajax: true
    , open_speed: 250
    , close_speed: 250
    , reload_wait: 500
    , scroll_speed: 300
    , scroll_blank: 60
  }
  , text: {
    confirm: 'こちらの内容で登録しますがよろしいですか'
  }
  , val: {
    url: null
    , open_start: false
    , end_init: false
  }
  , id: {
    popup_space: 'popup_form_service_edit_space'
  }

  , init: function () {
    var self = this;

    setTimeout (function () {
      self.val.end_init = true;
    }, 1);

    console.log ('popup_form_service init');
  }

  , set_unique_init_service: function (unique_init_service) {
    var self = this;
    self.unique_init_service = unique_init_service;
  }

  , modal_init: function () {
    var self = this;

    common_init_service.modal_init();
    self.unique_init_service.url = self.val.url;
    self.unique_init_service.modal_init();
  }

  //出力スペースのオブジェクト
  , popup_space_obj: function () {
    return $("#" + this.id.popup_space);
  }

  //HTMLをセットする
  , set_html: function (html) {
    var self = this;

    //HTMLをセット
    this.popup_space_obj().html (html);

    //セットしたHTML内のフォームの設定
    var form_obj = $('form', this.popup_space_obj());

    form_obj.submit(function () {
      //modal_mode=trueのパラメータを追加する
      $("<input />").attr("type", "hidden")
          .attr("name", "modal_mode")
          .attr("value", true)
          .appendTo(form_obj);
      //エンターの場合もAjax送信処理
      self.onclick_send(this);
      //フォームでの送信を止める
      return false;
    });
  }

  //編集画面を開く
  , onclick_open: function (url) {

    if ( ! this.val.end_init) return;

    //２重起動防止
    if (this.val.open_start) return;

    this.val.open_start = true;

    var self = this;
    this.val.url = url;

    if (this.conf.use_ajax) {
      $.ajax({
        type: "GET",
        url: this.val.url,
        data: {'modal_mode' : true},
      }).done(function(val){
        self.set_html (val);

        simple_popup_service.open({
          'href' : "#" + self.id.popup_space
          , openSpeed: self.conf.open_speed
          , closeSpeed: self.conf.close_speed
          , 'afterShow': function () {
            //console.log ('afterShow');
            self.val.open_start = false;
            self.modal_init();
          }
          , 'afterClose': function () {
            //console.log ('afterClose');
            self.val.open_start = false;
          }
        });
      }).fail(function(){
        // TODO: 多分通信失敗時はユーザーにエラー表示したほうが良いと思います
        console.log('Request failed!!!!!!!!!!!!!!!!!!!!!!!');
        self.val.open_start = false;
      });
    } else {
      location.href = url;
    }
  }

  //編集内容を送信
  , onclick_send: function (form) {
    var is_multipart        = $(form).attr('enctype') == 'multipart/form-data';
    var is_confirm_required = $(form).attr('is_confirm_required') == 'true';
    var confirm_message     = (typeof($(form).attr('confirm_message')) == 'undefined') ? this.text.confirm : $(form).attr('confirm_message');

    $(form).attr('modal_mode', true);

    console.log (is_multipart);
    console.log (is_confirm_required);

    var self = this;

    if (is_confirm_required) {
      if ( ! confirm (confirm_message) ) return;
      //prevent_double_clickだと非同期処理でボタンが不活化するため、確認ダイアログでキャンセルした場合その後ボタンが押せなくなってしまう。
      //なのでprevent_double_click_with_confirmを使用しこのタイミングで不活化する。
      $('.simple_popup_service_container .prevent_double_click_with_confirm').prop("disabled", true);
    }

    if (this.conf.use_ajax) {
      if (is_multipart) {
        var fd = dom_service.get_formdata (form);

        $.ajax({
          type: "POST",
          url: $(form).attr('action'),
          data: fd,
          dataType : "text",
          processData : false,
          contentType : false,
          success: function(val){
            self.set_html (val);
            self.modal_init();
            simple_popup_service.resize();
          },
          error: function(){
            console.log('エラー');
          }
        });
      } else {
        console.log($(form).serialize());
        $.ajax({
          type: "POST",
          url: $(form).attr('action'),
          data: $(form).serialize(),
          success: function(val){
            self.set_html (val);
            self.modal_init();
            simple_popup_service.resize();
          },
          error: function(val){
            self.set_html (val.responseText);
          }
        });
      }
    } else {
      form.submit ();
    }
  }

  //編集からのコールバック
  , callback: function (path = null, conversionType = null, conversionOptions = {}) {
    // コンバージョンイベントの発火
    if (conversionType && typeof onConversionComplete == 'function') {
      console.log('onConversionComplete call');
      onConversionComplete(conversionType, conversionOptions);
    }

    simple_popup_service.close();

    setTimeout (function () {
      if(path){
        location = path;
      } else {
        location = location.href;
      }
    }, this.conf.reload_wait);
  }

  //特定のオブジェクトにスクロール
  , scroll_to_target: function (target) {
    var target_top = target.offset().top - this.popup_space_obj().offset().top;
    var blank = this.conf.scroll_blank;
    var speed = this.conf.scroll_speed;

    var scroll_obj = simple_popup_service.popup_scroll_obj();

    if (scroll_obj) scroll_obj.animate({scrollTop: target_top - blank}, speed, "swing");
  }

};
window.popup_form_service = popup_form_service;
